import React, { FC } from 'react';
import { Box, Stack, SvgIcon, Typography } from '@mui/material';
import ErrorIcon from '../../assets/error.svg';

interface ErrorComponentProps {
    title?: string | null;
    message?: string | null;
}

const ErrorComponent: FC<ErrorComponentProps> = (props) => {
    const { title, message } = props;
    return (
        <Box sx={{ mx: 1 }} data-testid="ErrorComponent">
            <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ pt: 10 }}
            >
                <SvgIcon sx={{ width: 86, height: 86 }}><ErrorIcon /></SvgIcon>
                {title
                    && (
                        <Typography
                            sx={{
                                mt: 1.5,
                                fontFamily: 'Poppins',
                                fontWeight: '600',
                                fontSize: '24px',
                                lineHeight: '36px',
                                textAlign: 'center',
                            }}
                        >
                            {title}
                        </Typography>
                    )}
                {message
                    && (
                        <Typography
                            sx={{
                                mt: 1.5,
                                fontWeight: '400',
                                fontSize: '18px',
                                lineHeight: '24px',
                                textAlign: 'center',
                            }}
                        >
                            {message}
                        </Typography>
                    )}
            </Stack>
        </Box>
    );
};

export default ErrorComponent;

ErrorComponent.defaultProps = {
    title: 'An error has occured',
    message: null,
};
